<template>
  <div>
    <Categories></Categories>
  </div>
</template>

<script>
import Categories from "@/view/shop/home/Categories";

export default {
  name: "home",
  components: {
    Categories,
  },  
   data() {
     return {
      }
    },
  methods: {
  }
};
</script>
